var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabel18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "label-18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 288 0 288 864 0 864"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "18-&-24-Pixel-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Content",
    transform: "translate(-144.000000, -656.000000)",
    stroke: "#F5F5F5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 121.5,
    y: 45.5,
    width: 311,
    height: 1012
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    transform: "translate(0.000000, -480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 18
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Duplicate-control"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "grid-18",
    mask: "url(#mask-2)",
    x: 0,
    y: 480,
    width: 18,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0.000000, -480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "label-18",
    transform: "translate(0.000000, 480.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "grid-18",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00004688,6.0000625 C4.44803825,6.0000625 4.00003125,5.5520555 4.00003125,5.00004688 C4.00003125,4.44803825 4.44803825,4.00003125 5.00004688,4.00003125 C5.5520555,4.00003125 6.0000625,4.44803825 6.0000625,5.00004688 C6.0000625,5.5520555 5.5520555,6.0000625 5.00004688,6.0000625 M17.7082454,11.0051407 L8.9951093,2.29200456 C8.80810638,2.10500164 8.55510242,2 8.29009828,2 L2.99801559,2 C2.44700698,2 2,2.44700698 2,2.99801559 L2,8.29009828 C2,8.55410241 2.10500164,8.80810638 2.29200456,8.9951093 L11.0051407,17.7082454 C11.3941468,18.0972515 12.0261567,18.0972515 12.4161628,17.7082454 L17.7082454,12.4161628 C18.0972515,12.0261567 18.0972515,11.3941468 17.7082454,11.0051407",
    id: "icon",
    fill: "#6A7070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Slice",
    transform: "translate(0.000000, -480.000000)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel18);
export default __webpack_public_path__ + "static/media/label-18.103a3953044407ca7d517c9f9fd0e5d1.svg";
export { ForwardRef as ReactComponent };